export const SITE_PREFIX_CONTEXT_ID = 'sitePrefix';
